export const MESSAGES = {
    LOGIN_SUCCESS: "Login successful!",
    LOGIN_FAILED: "Login failed. Please try again.",
    INVALID_CREDENTIALS: "Invalid credentials. Please check your email and password.",
    LOGIN_AUTH: "Either password or otp must be provided",
    EMAIL_MANDATORY:"Email or Mobile is required",
    PASSWORD_LENGTH:"Password must be at least 6 characters",
    OTP_VALIDATION:"OTP must be exactly 5 digits",
    FAILED_FETCHED:"Failed to fetch the data",
    INVALID_EMAIL_PASSWORD:"Invalid email or mobile number",
    USERNAME_MANDATORY:"Username is required",  
    PASSWORD_MANDATORY:"Password is required",
};
